import React, { useRef } from "react";
import BlockingLoadingOverlayController from "../BlockingLoadingOverlay/BlockingLoadingOverlayController";
import { DebugButton, DebugButtonRow, DebugFormGroup } from "./debug.styles";

const DebugLoadingOverlay = () => {
  const titleRef = useRef<HTMLInputElement>(null);
  const messageRef = useRef<HTMLInputElement>(null);

  const getValues = () => ({
    title: titleRef.current?.value || undefined,
    message: messageRef.current?.value || undefined
  });

  return (
    <div>
      <DebugFormGroup>
        <label>Overlay Title</label>
        <input ref={titleRef} type="text" placeholder="e.g. Processing..." />
      </DebugFormGroup>
      <DebugFormGroup>
        <label>Overlay Message</label>
        <input ref={messageRef} type="text" placeholder="e.g. Please wait" />
      </DebugFormGroup>

      <DebugButtonRow style={{ marginTop: "0.75rem" }}>
        <DebugButton
          onClick={() => {
            BlockingLoadingOverlayController.startLoading({
              bg: "transparent",
              ...getValues()
            });
          }}
        >
          Show Loading
        </DebugButton>
        <DebugButton
          onClick={() => {
            BlockingLoadingOverlayController.loadingSuccess(getValues());
          }}
        >
          Show Success
        </DebugButton>
        <DebugButton
          className="danger"
          onClick={() => {
            BlockingLoadingOverlayController.loadingError(getValues());
          }}
        >
          Show Error
        </DebugButton>
        <DebugButton
          onClick={() => BlockingLoadingOverlayController.endLoading()}
        >
          Dismiss
        </DebugButton>
      </DebugButtonRow>
    </div>
  );
};

export default DebugLoadingOverlay;
